import { create } from "zustand";
import { CountryVersionEnum, LanguageEnum } from "@/services/type";

interface GeneralAppStateType {
  countryVersion?: CountryVersionEnum;
  language?: LanguageEnum;
  isGrowthbookLoaded: boolean;
}

interface AppState {
  generalAppState: GeneralAppStateType;
  setGeneralAppState: (state: GeneralAppStateType) => void;
  updateGeneralAppState: (updates: Partial<GeneralAppStateType>) => void;
}

export const initialGeneralAppState: GeneralAppStateType = {
  isGrowthbookLoaded: false,
};

export const useAppStore = create<AppState>((set) => ({
  generalAppState: initialGeneralAppState,
  setGeneralAppState: (state: GeneralAppStateType) =>
    set({ generalAppState: state }),
  updateGeneralAppState: (updates: Partial<GeneralAppStateType>) =>
    set((state) => ({
      generalAppState: { ...state.generalAppState, ...updates },
    })),
}));
